export const IncompatibleConstraints = 471;
